import { useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';

/**
 * Component that manages WebSocket connection lifecycle
 * Should be placed inside AuthProvider to access authentication state
 */
export default function WebSocketManager() {
  const { isConnected } = useWebSocket();

  useEffect(() => {
    console.log('WebSocket connection status:', isConnected ? 'Connected' : 'Disconnected');
  }, [isConnected]);

  // This component doesn't render anything
  return null;
}
